/**
 * Browser download helper for the debug Settings Neo4j backup tool.
 *
 * Uses authenticated fetch + saveBlob (same pattern as reports/docs) rather
 * than an RTK mutation — the response is a large binary attachment.
 */

import { downloadMaintenanceBackup } from './download-maintenance-backup'

export async function downloadNeo4jBackup(fileName: string): Promise<void> {
  return downloadMaintenanceBackup('Neo4j', 'neo4j-backup', fileName)
}
